import { BarChart3, LayoutTemplate, MessageSquareText, Workflow } from 'lucide-react';
import { usePointerScene } from './motion';
import './growthLoop.css';

/* Bottom-to-top: the four stages the platform connects. */
const LAYERS = [
  { id: 'capture', label: 'Capture', caption: 'Pages, forms, calls, QR', icon: LayoutTemplate, depth: 0 },
  { id: 'respond', label: 'Respond', caption: 'Instant replies, routing', icon: MessageSquareText, depth: 82 },
  { id: 'convert', label: 'Convert', caption: 'Pipeline, appointments', icon: Workflow, depth: 164 },
  { id: 'improve', label: 'Improve', caption: 'Sources, revenue, ranking', icon: BarChart3, depth: 246 },
];

export default function GrowthLoop3D() {
  const scene = usePointerScene();

  return (
    <div className="loop-stage" ref={scene.ref} onPointerMove={scene.onPointerMove} onPointerLeave={scene.onPointerLeave}>
      <div className="loop-scene" aria-hidden="true">
        <span className="loop-beam" />
        {LAYERS.map((layer, index) => {
          const Icon = layer.icon;
          return (
            <div className="loop-layer" key={layer.id} style={{ '--depth': `${layer.depth}px`, '--index': index }}>
              <div className="loop-layer-face">
                <header>
                  <span className="loop-layer-icon"><Icon size={15} /></span>
                  <span className="loop-layer-copy"><strong>{layer.label}</strong><small>{layer.caption}</small></span>
                </header>
                <div className="loop-layer-rows">
                  <span style={{ '--w': '84%' }} />
                  <span style={{ '--w': '62%' }} />
                  <span style={{ '--w': '71%' }} />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <ol className="loop-legend">
        {LAYERS.map(layer => (
          <li key={layer.id}><span /><strong>{layer.label}</strong><small>{layer.caption}</small></li>
        ))}
      </ol>
    </div>
  );
}
